import { Row, Col, Space, Modal } from "antd";
import { faPhone, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import  mail_icon  from "../../../../Assets/paymentIcon/mail_icon.png";
import "./style.css";
import { SectionCardWrapper } from "../../../../Components/UI/SectionCardWrapper";
import ThankYouCard from "../../../../Components/UI/ThankYouCard";
import { SectionCardHeading } from "../../ThankyouPage/style";
import { useIsMobile } from "../../../../Hooks";
import { withScroll } from "../../../../HOC";
import { Wrapper } from "../../../../Constant";


const SuccessPage = ({
  loanNumber = null,
  name='',
  appNo= null
}) => {
  const isMobile = useIsMobile();
  const errorHandler = (errorMsg) => {
      let errorText = errorMsg || "";
      Modal.error({
        title: <h3 style={{ fontWeight: "bold" }}>{"Error"}</h3>,
        closable: true,
        footer: null,
        icon: (
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            color={"#f03740ff"}
            size="2xl"
            style={{ marginRight: "10px" }}
          />
        ),
        content: (
          <div
            style={{
              fontSize: "16px",
              textAlign: "left",
              marginTop: "5px",
              marginBottom: "20px",
              fontWeight: "500",
            }}
          >
            {errorText}
          </div>
        ),
        afterClose() {
          Modal.destroyAll();
        },
      });
  };

  return (
    <>
      <div className="container" style={{ marginTop: "150px" }}>
        <Wrapper>
          <Row justify="space-between" gutter={[32, { xs: 32 }]}>
            {/* ---------------------------Congratulations Card----------------------------------- */}
            {isMobile && (
              <Col xs={24}>
                <ThankYouCard />
              </Col>
            )}
            <Col lg={18} md={15}>
              <SectionCardWrapper>
                <Row gutter={[0, 24]}>
                  <Col span={24}>
                    <Space direction="vertical">
                      <SectionCardHeading font_color="#00497b">
                        Hey {name},
                      </SectionCardHeading>
                      <label style={{ display: "block" }}>
                        {`Congratulations! Your loan has been disbursed and applied to your policy new business.`}
                      </label>
                    </Space>
                  </Col>
                   <Col span={24}>
                    {appNo && (
                      <label
                        style={{
                          display: "block",
                          fontSize: "12px",
                          fontWeight: "normal",
                        }}
                      >
                        For your Application No : <strong>{appNo}</strong> we have received payment confirmation. Please note for future reference.
                      </label>
                    )}
                  </Col>
                  <Col span={24}>
                    {loanNumber && (
                      <label
                        style={{
                          display: "block",
                          fontSize: "12px",
                          fontWeight: "normal",
                        }}
                      >
                        Payment Loan ID is <strong>{loanNumber}</strong>
                      </label>
                    )}
                  </Col>
                  {/* <Col span={24}>
                    <label
                      style={{
                        fontSize: "14px",
                        fontWeight: "normal",
                        display: "none",
                      }}
                    >
                      Thank you for renewing your policy.
                    </label>
                  </Col>
                  <Col span={24}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "normal",
                      }}
                    >
                      Incase of any queries,
                    </label>
                    <label style={{ fontSize: "14px", fontWeight: "normal" }}>
                      please reach out to our customer service on
                    </label>
                  </Col>
                  <Col lg={18} md={24} xs={24}>
                    <Row gutter={[0, { xs: 24, md: 16 }]}>
                      <Col lg={12} md={24} xs={24}>
                        <a href={"tel:18001024462"}>
                          <span style={{ fontSize: "14px" }}>
                            <FontAwesomeIcon icon={faPhone} color="#f26221" />
                            <span
                              style={{ color: "black", marginLeft: "10px" }}
                            >
                              {"1800 102 4462"}
                            </span>
                          </span>
                        </a>
                      </Col>
                      <Col lg={12} md={24} xs={24}>
                        <a href={"mailto:customercare@manipalcigna.com"}>
                          <span style={{ fontSize: "14px" }}>
                            <img
                              src={mail_icon}
                              style={{
                                width: "24px",
                                height: "18px",
                                display: "inline",
                              }}
                            />
                            <span
                              style={{ color: "black", marginLeft: "10px" }}
                            >
                              {"customercare@manipalcigna.com"}
                            </span>
                          </span>
                        </a>
                      </Col>
                    </Row>
                  </Col> */}
                </Row>
              </SectionCardWrapper>
            </Col>
            {/* --------------------------Dummy card----------------------------------- */}
            <Col lg={6} md={9}>
              <Row gutter={[0, { lg: 32, md: 32, xs: 0 }]}>
                {!isMobile && (
                  <Col span={24}>
                    <ThankYouCard />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Wrapper>
      </div>
    </>
  );
};

export default withScroll(SuccessPage);
